import { createContext } from "react";

export const CaptionTextContext = createContext(
  (_arg0: React.ReactNode) => undefined,
);
